import React, { useEffect, useRef } from 'react'
import NavBar from '../NavBar.component'
import Slider from '../Slider.component'
import SolutionVideo from './SolutionVideo.component'
import Footer from '../Footer.component'
import CustomScrollbar from '../CustomScrollbar.component'
import Clientele from '../Home/Clientele.component'
import TabContent from '../TabContent.component'
import Banner4 from "../../assets/Banner4.svg";
import Need9 from "../../assets/need-9.svg";
import NeedImg9 from "../../assets/NeedImg9.svg";
import thumbImg from '../../assets/SolutionsImage/vectorImages/3962702.jpg'

let css = `
    .active-tab{
        color: #fff;
        background-color: #174997;
    }
    .active-tab img{
        filter: invert(1);
    }
`;

export default function OnlineExamModule() {
    let scrollRef = useRef();
    const serviceBoxRef = useRef(null);

    // Scroll to the ServiceBox section when the page loads
    useEffect(() => {
        serviceBoxRef.current.scrollIntoView({ behavior: 'smooth' });
    }, []);
    return (
        <>
            <section className="">
                {/* NAVIGATION BAR */}
                <section className="">
                    <NavBar />
                </section>

                {/* NAV-CONTACT */}
                <section>{/* <NavContact/> */}</section>

                {/* HERO SLIDER */}
                <section>
                    <Slider images={[Banner4]} showDemoButton={true} />
                </section>

                {/* SOLUTION FOR YOUR UNIQUE BUSINESS NEEDS */}
                <section ref={serviceBoxRef}>
                    <section>
                        <style>{css}</style>
                        <div className="pt-16 custom-container">
                            <h1 className="text-center heading">
                                Solution for your unique business needs
                            </h1>
                            <p className="mt-3 text-sm text-center font-['montserrat']">
                                Explore our comprehensive range of solutions designed to
                                solve your specific challenges.
                            </p>
                        </div>
                        <div className="flex mb-12 mt-0 max-w-[80%] justify-center mx-auto items-center">
                            <div
                                className=" p-5 max-h-[770px]  overflow-y-auto scroll-smooth"
                                ref={scrollRef}
                            >
                                <TabContent
                                    index={8}
                                    icon={Need9}
                                    thumbnail={thumbImg}
                                    title={"Online Exam Module"}
                                    content={[
                                        `The Online Exam Management Software is an innovative solution that enables students to take exams from anywhere, anytime, and on any device. It provides a secure and efficient platform that allows teachers to manage and conduct exams, reducing the time and effort required to create and grade assessments manually.`,

                                        `The software offers a range of question formats, including multiple-choice, single-choice, and descriptive questions. It provides instant answers for MCQs, and answer validation for exams, ensuring a fair and transparent evaluation process.`,

                                        `With this software, students can take exams without having to be physically present in a specific location. This feature makes it convenient for students, especially those who live in remote areas or have a busy schedule. Additionally, the software saves teachers' time by automating the exam creation and grading process, allowing them to focus on other essential aspects of teaching.`,

                                        `Online Exam Management Software is a powerful tool that offers flexibility, convenience, and efficiency to both students and teachers, making the exam process easier and more accessible for all.`,
                                    ]}
                                    image={NeedImg9}
                                    // caption={["Education"]}
                                    captionWidth={"200px"}
                                />
                            </div>
                        </div>
                    </section>
                </section>

                {/* SOLUTION VIDEO */}
                <section>
                    <SolutionVideo
                        videoSrc="https://www.youtube.com/embed/fHUHS-Zav7Y"
                        videoTitle="Online Exam Module"
                    />
                </section>

                {/* CLIENTELE */}
                <section>
                    <Clientele />
                </section>

                {/* FOOTER */}
                <section>
                    <Footer />
                </section>

                <CustomScrollbar />
            </section>
        </>
    )
}
